import * as Yup from 'yup'

export const MailLoginOtpValidationSchema = Yup.object().shape({
  otpPassword: Yup.number().typeError('Uniquement des chiffres').required('Obligatoire'),
})
